import React, { useState } from "react";
import "./Action_Section.css";
import { IoClose } from "react-icons/io5";
import store from "../../../Assets/Home/Action_Section/store.png";
import DemoIcon from "../../../Assets/Icons/ai-star.png";
import VoiceIcon from "../../../Assets/Home/Action_Section/1.png";
import demoVideo from "../../../Assets/Video/demo-vid.mp4";
import CustomVideoPlayer from "./CustomVideoPlayer";
import InventoryIcon from "../../../Assets/Home/Action_Section/2.png";
import AnalyticsIcon from "../../../Assets/Home/Action_Section/3.png";
import AutoOrderIcon from "../../../Assets/Home/Action_Section/4.png";

export default function Action_Section() {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  const video = () => {
    setIsVideoOpen(true);
  }

  const closeVideo = () => {
    setIsVideoOpen(false);
  }

  return (
    <section id="demo" className="see-section">
      <div className="demo-btn">
        <img src={DemoIcon} alt="icon" className="demo-btn-icon" />
        Live Demo
      </div>
      <h2 className="see-title">See Fulupo in Action</h2>
      <div className="brush-line"></div>

      <p className="see-subtext">
        Experience the power of AI-driven store management. Watch our comprehensive
        demo or schedule a personalized session with our team.
      </p>
      <div className="demo-card">

        {/* LEFT IMAGE */}
        <div className="demo-left">
          <img src={store} alt="store" />

          <div className="overlay-demo">
            <div onClick={video} className="play-btn">
              <div className="play-triangle"></div>
            </div>

            <span>
              <h3 className="Tittle-left">Fulupo Store Demo</h3>
              <p className="Para-tittle">
                Click to watch our <br /> AI store management demo
              </p>
            </span>

          </div>
        </div>

        {/* RIGHT CONTENT */}
        <div className="demo-right">
          <h3 className="demo-heading">Fulupo Store Demo</h3>

          <p className="demo-desc">
            Complete walkthrough of store management features including voice AI,
            inventory tracking, and automated purchase orders.
          </p>

          <ul className="features">
            <li>
              <img src={VoiceIcon} className="feature-icon" alt="" />
              Voice Commands
            </li>

            <li>
              <img src={InventoryIcon} className="feature-icon" alt="" />
              Real-time Inventory
            </li>

            <li>
              <img src={AnalyticsIcon} className="feature-icon" alt="" />
              Smart Analytics
            </li>

            <li>
              <img src={AutoOrderIcon} className="feature-icon" alt="" />
              Auto Ordering
            </li>
          </ul>
        </div>
      </div>

      {isVideoOpen && (
        <div className="video-popup-overlay" onClick={closeVideo}>
          <div className="video-popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="video-popup-close" onClick={closeVideo}>
              <IoClose />
            </button>
            <div className="video-iframe-container">
              <CustomVideoPlayer videoSrc={demoVideo} autoPlay={true} />
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
